var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPinterest(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 4C0 1.79086 1.79086 0 4 0H20C22.2091 0 24 1.79086 24 4V20C24 22.2091 22.2091 24 20 24H4C1.79086 24 0 22.2091 0 20V4Z",
    fill: "#BD081C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5397 4C9.2506 4 6 6.19271 6 9.74145C6 11.9983 7.26947 13.2806 8.03884 13.2806C8.3562 13.2806 8.53893 12.3958 8.53893 12.1457C8.53893 11.8476 7.77917 11.2129 7.77917 9.97226C7.77917 7.39486 9.74108 5.5676 12.28 5.5676C14.4631 5.5676 16.0788 6.80821 16.0788 9.08748C16.0788 10.7897 15.396 13.9826 13.184 13.9826C12.3858 13.9826 11.703 13.4056 11.703 12.5785C11.703 11.3667 12.5493 10.1935 12.5493 8.94322C12.5493 6.82103 9.53912 7.20572 9.53912 9.7703C9.53912 10.3089 9.60644 10.9051 9.84686 11.3956C9.40448 13.2998 8.50046 16.1369 8.50046 18.0988C8.50046 18.7046 8.58702 19.3009 8.64472 19.9068C8.75371 20.0286 8.69922 20.0158 8.86591 19.9549C10.4816 17.7429 10.4239 17.3102 11.1548 14.4154C11.5491 15.1655 12.5685 15.5694 13.3764 15.5694C16.7808 15.5694 18.31 12.2515 18.31 9.26059C18.31 6.07731 15.5595 4 12.5397 4Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinterest);
export default __webpack_public_path__ + "static/media/pinterest.f87790a9c49fe188aa2565b29dda6c7f.svg";
export { ForwardRef as ReactComponent };